module.exports = __webpack_public_path__ + "static/media/foodpanda.f07d80ef.jpeg";